import OrderRequestIcon from '@assets/CustomIcons/order-request-icon-solid.svg'
import { TransportationOrderFlag } from '@components/_SiteWide/Flags/FlagIcon'
import { OrderRequestPopover } from '@components/_SiteWide/OrderRequestPopover'
import { BBDTag, Horizontal, Texto, Vertical } from '@gravitate-js/excalibrr'

export function isOrderRequest(order) {
  return [OrderRequestType.OrderRequestAccepted, OrderRequestType.OrderRequestRequested].includes(order?.type)
}

export const OrderRequestType = {
  OrderRequestRequested: 'Order Request (Requested)',
  OrderRequestAccepted: 'Order Request (Acknowledged)',
  Backhaul: 'Backhaul',
  SiteDelivery: 'Site Delivery',
} as const

function getFilterOptions() {
  const fragments = window.location.pathname.split('/')
  const pathTerminal = fragments[fragments.length - 1]
  let options = ['Backhaul', 'Site Delivery']

  if (!['all', 'carrier-dispatch'].includes(pathTerminal)) {
    options = ['Order Request (Requested)', 'Order Request (Acknowledged)', ...options]
  }

  return options
}

export const OrderColumn = (hide?: boolean) => {
  return {
    headerName: 'Order',
    field: 'number',
    filter: 'agMultiColumnFilter',
    hide,
    minWidth: 110,
    cellRenderer: 'agGroupCellRenderer',
    cellRendererParams: {
      // The agGroupCellRenderer will use this inner renderer
      innerRenderer: (params) => {
        const { data } = params

        if (data?.type?.includes('Order Request')) {
          const text = data?.type?.includes('Accepted') ? data.number : 'Request'
          const backgroundColor = data?.type?.includes('Accepted')
            ? 'var(--theme-color-2-dim)'
            : 'var(--theme-option-dim)'

          const hoverElement = (
            <BBDTag style={{ width: 'fit-content', backgroundColor, border: 'none' }}>
              <Horizontal verticalCenter>
                <img src={OrderRequestIcon} style={{ maxWidth: '17px' }} className='mr-2' />
                {text}
              </Horizontal>
            </BBDTag>
          )
          return (
            <OrderRequestPopover
              requestItem={data?.order_request_info}
              origins={data?.loads?.map((load) => load.location_name)}
              acceptBy={data?.accept_by}
              note={data?.note}
              timezone={data?.dispatch_window_start_local}
              hoverElement={hoverElement}
            />
          )
        }

        if (data?.type?.toLowerCase() === 'backhaul') {
          return (
            <BBDTag
              style={{
                width: 'fit-content',
                background: 'var(--ag-border-color)',
                border: 'none',
              }}
            >
              <Horizontal verticalCenter>
                <TransportationOrderFlag /> <Texto className='ml-2'> {data.number}</Texto>
              </Horizontal>
            </BBDTag>
          )
        }

        return (
          <Vertical justifyContent='center'>
            <span className='font-bold'>{data?.number}</span>
          </Vertical>
        )
      },
      // Other agGroupCellRenderer params if needed
      suppressCount: false, // Show/hide count
      checkbox: false, // Show/hide checkbox for selection
    },
    filterParams: {
      filters: [
        {
          filter: 'agSetColumnFilter',
          display: 'subMenu',
          title: 'Filter By Number',
          filterParams: {
            field: 'number',
            buttons: ['reset'],
          },
        },
        {
          filter: 'agSetColumnFilter',
          display: 'subMenu',
          title: 'Filter By Type',
          filterParams: {
            showTooltips: true,
            field: 'type',
            values: getFilterOptions(),
            valueGetter: ({ data }) => {
              if (data?.type === 'backhaul') return 'Backhaul'
              if (data?.type === 'regular') return 'Site Delivery'
              if (data?.type === 'Order Request (Accepted)') return 'Order Request (Acknowledged)'
              return data.type
            },
            buttons: ['reset'],
          },
        },
      ],
    },
  }
}
